var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"down-top-padding",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-toolbar-title',[_vm._v("Dashboard")])],1)],1),_c('SumarryReports',{attrs:{"isActive":"All"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }